<div class="grid">
    <h2>{{ "dtmMainPageLib.subpage.kpo.competition.documents.allDocumentsTitle" | transloco }}</h2>
    <p>{{ "dtmMainPageLib.subpage.kpo.competition.documents.allDocumentsDescription" | transloco }}</p>
    <div class="documents">
        <div class="section full no-subtitle">
            <ul class="all-documents">
                <ng-container *ngFor="let file of ALL_COMPETITION_FILES">
                    <ng-container *ngTemplateOutlet="fileListItemTemplate; context: { $implicit: file }"></ng-container>
                </ng-container>
            </ul>
        </div>
    </div>

    <h2>{{ "dtmMainPageLib.subpage.kpo.competition.documents.standaloneFilesTitle" | transloco }}</h2>
    <p>{{ "dtmMainPageLib.subpage.kpo.competition.documents.standaloneFilesDescription" | transloco }}</p>
    <div class="documents">
        <div class="section">
            <h3>{{ "dtmMainPageLib.subpage.kpo.competition.documents.basicDocumentsTitle" | transloco }}</h3>
            <ul>
                <ng-container *ngFor="let file of KPO_BASE_FILES">
                    <ng-container *ngTemplateOutlet="fileListItemTemplate; context: { $implicit: file }"></ng-container>
                </ng-container>
            </ul>
        </div>
        <div class="section">
            <h3>{{ "dtmMainPageLib.subpage.kpo.competition.documents.firstStageDocumentsTitle" | transloco }}</h3>
            <ul>
                <ng-container *ngFor="let file of FIRST_PHASE_FILES">
                    <ng-container *ngTemplateOutlet="fileListItemTemplate; context: { $implicit: file }"></ng-container>
                </ng-container>
            </ul>
        </div>
        <div class="section full">
            <h3>{{ "dtmMainPageLib.subpage.kpo.competition.documents.secondStageDocumentsTitle" | transloco }}</h3>
            <ul>
                <ng-container *ngFor="let file of SECOND_PHASE_FILES">
                    <ng-container *ngTemplateOutlet="fileListItemTemplate; context: { $implicit: file }"></ng-container>
                </ng-container>
            </ul>
        </div>
        <div class="section">
            <h3>{{ "dtmMainPageLib.subpage.kpo.competition.documents.ownAnalysisMaterialsTitle" | transloco }}</h3>
            <ul>
                <ng-container *ngFor="let file of OWN_ANALYSIS_FILES">
                    <ng-container *ngTemplateOutlet="fileListItemTemplate; context: { $implicit: file }"></ng-container>
                </ng-container>
            </ul>
        </div>
        <div class="section">
            <h3>{{ "dtmMainPageLib.subpage.kpo.competition.documents.trainingCentersMaterialsTitle" | transloco }}</h3>
            <ul>
                <ng-container *ngFor="let file of TRAINING_CENTERS_FILES">
                    <ng-container *ngTemplateOutlet="fileListItemTemplate; context: { $implicit: file }"></ng-container>
                </ng-container>
            </ul>
        </div>
    </div>
</div>
<ng-template #fileListItemTemplate let-file>
    <li>
        <a [href]="file.url" download target="_blank" class="button-link">{{ file.name }}</a>
    </li>
</ng-template>
